import { render, staticRenderFns } from "./ContactPersonPicker.vue?vue&type=template&id=44ff137e&scoped=true"
import script from "./ContactPersonPicker.vue?vue&type=script&lang=ts"
export * from "./ContactPersonPicker.vue?vue&type=script&lang=ts"
import style0 from "./ContactPersonPicker.vue?vue&type=style&index=0&id=44ff137e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ff137e",
  null
  
)

export default component.exports